export type CsvColumn<T> = {
  id: string;
  header: string;
  actions?: boolean;
  csvValue?: (row: T) => string | number | null | undefined;
  sortValue?: (row: T) => string | number | Date | null | undefined;
};

function escapeCsvCell(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function cellText<T>(col: CsvColumn<T>, row: T): string {
  const raw = col.csvValue?.(row) ?? col.sortValue?.(row);
  if (raw == null || raw === '') return '';
  if (raw instanceof Date) return raw.toISOString();
  return String(raw);
}

export function exportTableCsv<T>(
  columns: CsvColumn<T>[],
  rows: T[],
  filename = 'export.csv'
) {
  const exportCols = columns.filter((c) => !c.actions && c.header.trim());
  const header = exportCols.map((c) => escapeCsvCell(c.header)).join(',');
  const body = rows
    .map((row) => exportCols.map((col) => escapeCsvCell(cellText(col, row))).join(','))
    .join('\n');
  const csv = `${header}\n${body}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
